import type { ReactNode } from "react";

import { EmptyState } from "../ui";

/**
 * Vacío de una tabla, distinguiendo **por qué** está vacía.
 *
 * «Sin resultados» a secas se confunde con «se rompió algo», y con un filtro
 * puesto manda a buscar el fallo donde no está. Cuando hay filtros activos,
 * el mensaje lo dice y ofrece quitarlos.
 */
export function DataTableEmptyState({
  title,
  description,
  action,
  filtered,
  onClearFilters,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  filtered: boolean;
  onClearFilters: () => void;
}) {
  if (filtered) {
    return (
      <div className="px-4 py-10 text-center">
        <p className="text-sm font-medium text-slate-200">Ningún resultado con estos filtros</p>
        <p className="mx-auto mt-1 max-w-md text-sm text-slate-500">
          Hay datos en esta tabla, pero ninguno coincide con la búsqueda o los filtros activos.
        </p>
        <button
          type="button"
          onClick={onClearFilters}
          className="mt-3 rounded-lg border border-white/15 bg-white/[0.04] px-3 py-1.5 text-sm text-slate-200 transition hover:bg-white/[0.09]"
        >
          Quitar filtros
        </button>
      </div>
    );
  }

  return (
    <div className="px-4 py-8">
      <EmptyState title={title} description={description} />
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}
